var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 2.84126C28.8962 3.32363 27.71 3.64848 26.465 3.79491C27.7363 3.04553 28.7125 1.85808 29.1712 0.442986C27.9825 1.137 26.665 1.64151 25.2625 1.91345C24.1412 0.735849 22.54 0 20.77 0C16.7962 0 13.8763 3.64971 14.7738 7.43847C9.66 7.18622 5.125 4.77441 2.08875 1.1087C0.47625 3.83183 1.2525 7.39417 3.9925 9.19811C2.985 9.16612 2.035 8.89417 1.20625 8.44011C1.13875 11.2469 3.1825 13.8728 6.1425 14.4573C5.27625 14.6887 4.3275 14.7428 3.3625 14.5607C4.145 16.9676 6.4175 18.7186 9.1125 18.7678C6.525 20.765 3.265 21.6571 0 21.2781C2.72375 22.9971 5.96 24 9.435 24C20.8625 24 27.3187 14.4992 26.9287 5.97785C28.1312 5.12264 29.175 4.05578 30 2.84126Z",
    fill: "#00ACEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.e05397dba3ef70a66c29b98af1a722d2.svg";
export { ForwardRef as ReactComponent };